import _ from 'lodash';
import { VISIT_STATUS } from 'app/config/visits.js';
const TEMPLATE_NAME = 'CLINICAL_CENTER_PEP';
const initialState = () => ({
  loading: false,
  isFirstLoad: true,
  loadedData: []
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true,
        isFirstLoad: state.isFirstLoad
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false,
        isFirstLoad: false
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;
      return {
        ...state,
        loading: false,
        isFirstLoad: false,
        loadedData: newData
      };
    }
    case `${TEMPLATE_NAME}_CREATE`: {
      const newRow = action.payload;
      const loadedData = [...state.loadedData, newRow];
      const visitsOrder = _.sortBy(loadedData, elem => elem.visitStatus !== VISIT_STATUS.PLANNED);
      return {
        ...state,
        loading: false,
        loadedData: visitsOrder
      };
    }
    case `${TEMPLATE_NAME}_UPDATE`: {
      const visit = action.payload;
      const cloadedData = _.cloneDeep(state.loadedData);

      const loadedData = cloadedData.map(item => {
        return visit.id === item.id ? visit : item;
      });
      return {
        ...state,
        loading: false,
        loadedData
      };
    }
    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
